/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CustomWidgetNode.vue?vue&type=template&id=59ccdaf1&scoped=true&"
import script from "./CustomWidgetNode.vue?vue&type=script&lang=js&"
export * from "./CustomWidgetNode.vue?vue&type=script&lang=js&"
import style0 from "./CustomWidgetNode.vue?vue&type=style&index=0&id=59ccdaf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ccdaf1",
  null
  
)

export default component.exports